const powerEvolution = {
  base: {
    arrow: 1,
    price: 41.24,
    origin: 'UK DA Base',
    currency: '£ / MWh',
  },
  peak: {
    arrow: -1,
    price: 41.87,
    origin: 'UK DA Peak',
    currency: '£ / MWh',
  },
};

export default powerEvolution;
